const UserStatusTypes = {
    inactive: 0,
    active: 1,
} as const;

export { UserStatusTypes };
